
import SourceLink from 'components/SourceLink';
import React from 'react';
import {
  MdTimer,
  MdDashboard,
  MdExtension,
  MdInsertChart,
  MdKeyboardArrowDown,
  MdViewDay,
  MdSchool,
  MdPeople,
  MdLocalLibrary,
  MdPieChart,
  MdNavigation,
  MdPermDataSetting,
  MdCollectionsBookmark,
} from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import {
  // UncontrolledTooltip,
  Collapse,
  Nav,
  Navbar,
  Button,
  NavItem,
  NavLink as BSNavLink,
} from 'reactstrap';
import bn from 'utils/bemnames';
import { USER_ROLES } from '../../utils/user-role';
import logoAppsWhite from 'assets/img/logo/logo-adipsik-white.png';
import logoAksi from 'assets/img/logo/logo-apps-white.png';
import { MdClearAll } from 'react-icons/md';

// const navContents = [
//   { to: '/typography', name: 'typography', exact: false, Icon: MdTextFields },
//   { to: '/tables', name: 'tables', exact: false, Icon: MdBorderAll },
// ];

// const pageContents = [
//   { to: '/login', name: 'login / signup', exact: false, Icon: MdAccountCircle },
//   {
//     to: '/login-modal',
//     name: 'login modal',
//     exact: false,
//     Icon: MdViewCarousel,
//   },
// ];

const navItem = [
  { to: '/adm_dashboard', name: 'dashboard', exact: true, Icon: MdDashboard },
  { to: '/soal', name: 'soal', exact: true, Icon: MdLocalLibrary },
  { to: '/sekolah', name: 'sekolah', exact: true, Icon: MdSchool },
  { to: '/siswa', name: 'akun siswa', exact: true, Icon: MdPeople },
  { to: '/report', name: 'Laporan', exact: true, Icon: MdInsertChart },
  { to: '/config', name: 'Config', exact: true, Icon: MdPermDataSetting },
];

const navComponents = [
  { to: '/kategori_materi', name: 'kategori materi', exact: true, Icon: MdViewDay },
  { to: '/materi', name: 'materi', exact: true, Icon: MdViewDay },
  { to: '/kelas', name: 'kelas', exact: true, Icon: MdViewDay },
  { to: '/mapel', name: 'mapel', exact: true, Icon: MdViewDay },
];

const navItemSekolah = [
  { to: '/sekolah_dashboard', name: 'dashboard', exact: true, Icon: MdDashboard },
  { to: '/jadwal', name: 'Jadwal', exact: true, Icon: MdTimer },
  { to: '/userakun', name: 'Manajemen Akun', exact: true, Icon: MdPeople },
  { to: '/report_sekolah', name: 'Analisa', exact: true, Icon: MdPieChart },
  { to: '/trackingPengerjaan', name: 'Tracking & Report', exact: true, Icon: MdNavigation },
  // { to: '/report_analysis', name: 'Report Analysis', exact: true, Icon: MdInsertChart },  
  // { to: '/kelas', name: 'Pembagian Kelas', exact: true, Icon: MdViewDay },
];



const defaultNavItemSiswa = [
  { to: '/userhome', name: 'dashboard', exact: true, Icon: MdDashboard },
  { to: '/siswa/report', name: 'report', exact: true, Icon: MdInsertChart },
  { to: '/siswa/snbt', name: 'snbt', exact: true, Icon: MdCollectionsBookmark },
];

const bem = bn.create('sidebar');

class Sidebar extends React.Component {
  static defaultProps = {
    navItemSiswa: defaultNavItemSiswa,
  };

  constructor(props) {
    super(props);
    this.state = {
      isOpenComponents: true,
      isOpenContents: true,
      isOpenPages: true,
      sekolah: JSON.parse(localStorage.getItem('sekolah')),
    };
  }

  componentDidMount() {
    this._sekolahPollInterval = window.setInterval(() => {
      if (this.state.sekolah) return;
      const sekolah = JSON.parse(localStorage.getItem('sekolah'));
      if (sekolah) {
        this.setState({ sekolah });
      }
    }, 500);
  }

  componentWillUnmount() {
    if (this._sekolahPollInterval) {
      window.clearInterval(this._sekolahPollInterval);
    }
  }


  handleClick = (name) => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];

      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };

  handleSidebarControlButton = event => {
    event.preventDefault();
    event.stopPropagation();
    document.querySelector('.cr-sidebar').classList.toggle('cr-sidebar--open');
  };

  render() {
    // require("./sidebar.css");
    var navItems = [];
    let isAdmin = false;
    const user = JSON.parse(localStorage.getItem('user'))
    const sekolah = this.state.sekolah || JSON.parse(localStorage.getItem('sekolah'))
    if (user) {
      const roles = user.roles;
      if (roles.includes(USER_ROLES.ADMIN)) {
        navItems = navItem;
        isAdmin = true;
      }
      if (roles.includes(USER_ROLES.SEKOLAH)) {
        navItems = navItemSekolah;
      }
      if (roles.includes(USER_ROLES.SISWA)) {
        let items = [...(this.props.navItemSiswa || defaultNavItemSiswa)];

        const enableReport = sekolah ? sekolah.enableReport !== false : true;
        if (!enableReport) {
          items = items.filter(item => item.name !== 'report');
        }

        items = items.map(item => {
          if (item.name === 'report') {
            return {
              ...item,
              to: '/siswa/report/' + user.referenceId + '/' + user.userProfile.userAuthId,
            };
          }
          if (item.name === 'snbt') {
            return {
              ...item,
              to: '/siswa/snbt/' + user.userProfile.userAuthId,
            };
          }
          return item;
        });

        navItems = items;
      }

    }

    return (
      <aside className={bem.b()} >
        <div className={bem.e('background')} />
        <div className={bem.e('content')}>
          <Navbar className="d-flex logo-pnl">
            <SourceLink className="d-flex">
              <img
                src={logoAppsWhite}
                className="pr-2"
                alt="" style={{ width: '130px' }}
              />
              <div style={{ fontSize: '12px' }}>
                by
              </div>
              <img
                src={logoAksi}
                className="pr-2"
                alt="" style={{ width: '60px', height: '26px' }}
              />
            </SourceLink>
          </Navbar>
          <Nav vertical>
            {navItems.map(({ to, name, exact, Icon }, index) => (
              <NavItem key={index} className={bem.e('nav-item')}>
                <BSNavLink
                  id={`navItem-${name}-${index}`}
                  className="text-uppercase"
                  tag={NavLink}
                  to={to}
                  activeClassName="active"
                  exact={exact}
                >
                  <Icon className={bem.e('nav-item-icon')} />
                  <span className="">{name}</span>
                </BSNavLink>
              </NavItem>
            ))}

            {isAdmin && <>
              <NavItem
                className={bem.e('nav-item')}
                onClick={() => this.handleClick('Components')}
              >
                <BSNavLink className={bem.e('nav-item-collapse')}>
                  <div className="d-flex">
                    <MdExtension className={bem.e('nav-item-icon')} />
                    <span className=" align-self-start">Master Data</span>
                  </div>
                  <MdKeyboardArrowDown
                    className={bem.e('nav-item-icon')}
                    style={{
                      padding: 0,
                      transform: this.state.isOpenComponents
                        ? 'rotate(0deg)'
                        : 'rotate(-90deg)',
                      transitionDuration: '0.3s',
                      transitionProperty: 'transform',
                    }}
                  />
                </BSNavLink>
              </NavItem>
              <Collapse isOpen={this.state.isOpenComponents}>
                {navComponents.map(({ to, name, exact, Icon }, index) => (
                  <NavItem key={index} className={bem.e('nav-item')}>
                    <BSNavLink
                      id={`navItem-${name}-${index}`}
                      className="text-uppercase"
                      tag={NavLink}
                      to={to}
                      activeClassName="active"
                      exact={exact}
                    >
                      <Icon className={bem.e('nav-item-icon')} />
                      <span className="">{name}</span>
                    </BSNavLink>
                  </NavItem>
                ))}
              </Collapse>
            </>}
            <div style={{width: '100%', position: 'absolute', bottom: '0', display: 'flex', justifyContent: 'end', paddingRight: '20px'}}>
              <Button outline onClick={this.handleSidebarControlButton}>
                <MdClearAll size={25} onClick={this.handleSidebarControlButton} />
              </Button>
            </div>

          </Nav>
        </div>
      </aside>
    );
  }
}


export default Sidebar;
